/** @module Enums */ /** typedoc */

/**
 * Monetization Dsps : FacebookAudioLibrary, FacebookFingerprinting, YouTube
 */
export enum ReleaseStoreEnum {
    Amazon = 'Amazon',
    Beatport = 'Beatport',
    Deezer = 'Deezer',
    FacebookAudioLibrary = 'FacebookAudioLibrary',
    FacebookFingerprinting = 'FacebookFingerprinting',
    GooglePlay = 'GooglePlay',
    IHeartRadio = 'IHeartRadio',
    ITunes = 'ITunes',
    Other = 'Other',
    Pandora = 'Pandora',
    Recognition = 'Recognition',
    Spotify = 'Spotify',
    Tidal = 'Tidal',
    YouTube = 'YouTube',
    YouTubeMusic = 'YouTubeMusic',
    TikTok = 'TikTok',
}

export enum ReleaseStoreLabelEnum {
    Amazon = 'Amazon',
    Beatport = 'Beatport',
    Deezer = 'Deezer',
    FacebookAudioLibrary = 'Facebook Audio Library',
    FacebookFingerprinting = 'Facebook Fingerprinting',
    GooglePlay = 'GooglePlay',
    IHeartRadio = 'iHeartRadio',
    ITunes = 'iTunes',
    Other = 'Other',
    Pandora = 'Pandora',
    Recognition = 'Recognition',
    Spotify = 'Spotify',
    Tidal = 'Tidal',
    YouTube = 'YouTube',
    YouTubeMusic = 'YouTube Music',
    TikTok = 'TikTok',
}
